export const SET_CART = 'cart/SET';
export const TOGGLE = 'cart/TOGGLE';
export const ADD_PRODUCTS_TO_CART = 'cart/ADD_PRODUCTS_TO_CART';
export const SELECT_PRODUCT_FOR_CHECKOUT = 'wishList/SELECT_PRODUCT_FOR_CHECKOUT';
export const CHANGE_QUANTITY = 'cart/CHANGE_QUANTITY';
export const REMOVE = 'cart/REMOVE';
export const CLEAR = 'cart/CLEAR';
